import React from 'react'
import { SegmentedToggle } from '../../../ui'

/**
 * Prep-card-local segmented bar. Thin wrapper over the SegmentedToggle
 * primitive that translates the prep card's `{ value, label }` value
 * shape — preserved for back-compat with existing card data.
 */
export function SegmentedBar({ options, value, onChange, disabled }) {
  const selected = value?.value ?? null
  return (
    <div style={{ padding: '12px 14px' }}>
      <SegmentedToggle
        ariaLabel="Pick an option"
        options={options}
        value={selected}
        onChange={(next) => {
          const opt = options.find((o) => o.value === next)
          if (opt) onChange({ value: opt.value, label: opt.label })
        }}
        disabled={disabled}
      />
    </div>
  )
}
